export const pt = {
  changePassword: "Alterar a senha",
  passwordConf: "Nova confirmação de senha",
  errorText: {
    oops: "Ops. Parece que esse link expirou.",
    sendNew: "Clique aqui para enviar um novo link.",
    invalidLink: "Link inválido",
  },
};
